import { exists, t, TOptions } from 'i18next'

export const translate = (key: string, options: TOptions = {}, fallbackString?: string): string => {
  if (exists(key, options)) {
    return t(key, options)
  } else {
    console.warn(`Translation does not exist: '${key}'`)
    return fallbackString || `[*] Translation '${key}' does not exist`
  }
}
